<template>
	<div>
	<customer-nav-header :headerTitle="'Select a '  | headerTitleText" :customCSS='customCSS'/>
			<!--<count-down-timer />-->
		<b-tabs content-class="mt-3">
			<b-tab title="Click&Collect" active @click="getTabSlots('clickandcollect')">
				<div class="border w-100">
					<div class="scrollmenu">
						<a v-for="(day, index) in dates" @click="getDay(index, 'clickandcollect')" :key="day">{{  new Date() | moment("add", index + " days", "ddd D") }}</a>
					</div>
					<div id="slot-container">
						<ul>
							<li v-for="(slot, index) in slots" :key="index" @click="showSlotConfirmationModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, setClass(slot.status, slot.slot_time, slot.slotDate))"><div class="border p-3" :class="setClass(slot.status, slot.slot_time, slot.slotDate)">{{ slot.slot_time}} <span class='pl-4'> </span>{{ setClass(slot.status, slot.slot_time, slot.slotDate)}} <span class='pl-4'> </span></div></li>
						</ul>
					</div>
				</div>
			</b-tab>
			<b-tab title="Locker" @click="getTabSlots('locker')">
				<div class="border w-100">
					<div class="scrollmenu">
						<a v-for="(day, index) in dates" @click="getDay(index, 'locker')" :key="day">{{  new Date() | moment("add", (index + sameDay) + " days", "ddd D") }}</a>
					</div>				
					<div id="slot-container">
						<ul>
							<li v-for="(slot, index) in slots" :key="index" @click="showSlotConfirmationModal(slot.id, slot.slotDate, slot.day, slot.slot_time, slot.slot_type, setClass(slot.status, slot.slot_time, slot.slotDate))"><div class="border p-3" :class="setClass(slot.status, slot.slot_time, slot.slotDate)">{{ slot.slot_time}}<span class='pl-4'> </span>{{ setClass(slot.status, slot.slot_time, slot.slotDate)}} <span class='pl-4'> </span></div></li>
						</ul>
					</div>
				</div>
			</b-tab>		
		</b-tabs>
	</div>
</template>

<script>
import CustomerNavHeader from './CustomerNavHeader'
import {RepositoryFactory} from '../api/RepositoryFactory'
import {mixin} from '../mixins/clickAndCollectMixins'
const SlotsRepo = RepositoryFactory.get('slots')

//import CountDownTimer from './CountDownTimer'	
export default {
  name: 'MobileCustomerSlotCalendar',
	components: {CustomerNavHeader},
  props: {
    msg: String
  },
	mixins: [mixin],
  data() {
	return{	
		customCSS:{
			bgColor: '#AA090A',
			fontColor: '#fff'
		},
		slots : null,
		sameDay: 0,
		form: {
			customerName: '',
			orderEmail: '',
			orderMobileNumber: '',
			orderId: '',
			slotId:	'',
			slotType: '',
			slotTime: ''
		},
		typeText: '',
		selectedSlotDay: '',
		selectedSlotDate: '',
		selectedSlotTime: '',
		selectedSlotId: '',
		selectedSlotType: '',
		fullPage: false,
		formSubmitted: false,
		} 	
	},
	created()
	{
		//console.log(SlotsRepo)
		this.fetchGetSlots(0);
	},
	methods: {
		getTabSlots(type){
			if(type == "clickandcollect")
			{
				this.fetchGetClickAndCollectSlots(0)
			}
			else
			{
				this.fetchGetLockerSlots(0)
			}
		},
		async fetchGetSlots(index){
			const {data} =	await SlotsRepo.getSlots()
			this.slots = data[index]
					this.$nextTick().then(() => {
			this.$nextTick().then(() => {
					//this.slots = data[index]
					console.log(data)	
				});
			});
		},
		createDates(){
			var dates = [];
			var i
			for(i = 1; i < 29; i++)
			{
				let value = "Day" + i;
				dates.push(value)
			}
		},
		showSlotConfirmationModal(slotId, slotDate, slotDay, slotTime, slotType, slotStatus)
		{
			if(slotStatus === 'Available')
			{
				this.typeText = (slotType === 'locker')? 'Locker Booking' : 'Click and Collect Booking'
				this.selectedSlotDay = slotDay
				this.selectedSlotDate = slotDate
				this.selectedSlotTime = slotTime
				this.selectedSlotType = slotType
				this.form.slotType = slotType
				this.form.slotDate = slotDate
				this.form.slotTime = slotTime
				this.form.slotId = slotId
				this.showCustomerSlotConfirmationModal()
			}
		}
	},
	computed:{
		dates: function(){
		var dates = [];
		var i
		for(i = 1; i < 29; i++)
		{
			let value = "Day " + i;
			dates.push(value)
		}
			return dates
		}
	},
	filters: {

	}
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Available{
color: white;
background-color: green
}

.Unavailable{
color: white;
background-color: red
}
ul{
padding-inline-start: 0px;
}
li{
list-style-type:none
}

div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}
</style>
